import axios from "axios";

const baseUrl = process.env.REACT_APP_BACKEND_URL + "api/auth";

const useLogin = () => {
  const login = async (email, password) => {
    try {
      const response = await axios.post(
        `${baseUrl}/login`,
        {
          email,
          password,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return {
        token: response.data.token,
        company: response.data.company,
      };
    } catch (error) {
      console.error("Error logging in:", error);
      throw error;
    }
  };

  return {
    login,
  };
};

export default useLogin;
